import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useAdmin() {
  const { user } = useAuth();
  const userId = user?.id ?? null;
  const [isAdmin, setIsAdmin] = useState(false);
  // The user the answer in `isAdmin` belongs to; undefined before the first check.
  const [checkedFor, setCheckedFor] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let alive = true;
    const checkAdminStatus = async () => {
      if (!userId) {
        setIsAdmin(false);
        setCheckedFor(null);
        return;
      }

      let admin = false;
      try {
        const { data, error } = await supabase
          .rpc('has_role', { _user_id: userId, _role: 'admin' });

        if (error) {
          console.error('Error checking admin status:', error);
        } else {
          admin = data === true;
        }
      } catch (err) {
        console.error('Error checking admin status:', err);
      }
      if (!alive) return;
      setIsAdmin(admin);
      setCheckedFor(userId);
    };

    checkAdminStatus();
    return () => {
      alive = false;
    };
  }, [userId]);

  // Loading again from the render in which the session arrives, so a page that
  // redirects non-admins does not turn away an admin whose check is still out.
  const loading = checkedFor !== userId;
  return { isAdmin: isAdmin && !loading, loading };
}
